module.exports = __webpack_public_path__ + "sideSprite-9f5cfd935edfe77788951d7914a65665.png";